export default __webpack_public_path__ + "0524d9c.png";